import check from 'media/check.svg'
import closeRed from 'media/close-red.svg'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import cn from 'classnames'
import { FormattedMessage, useIntl } from 'react-intl'

import { fetchPricing, setCoupon } from '../../store/pricingSlice'
import messages from './messages'
import { AppDispatch } from 'js/app'
import { useSelector } from 'react-redux'
import {
  selectIsPremium,
  selectSubscriptionExpiryTime,
} from '../../store/userSlice'
import { isSubscriptionExpiringWithinDays } from '../../utils/partnerRedeemUtils'

function upperFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

type Props = {
  rootUrl: string
  partner: string
  couponPrefix: string
  partnerBoxClasses: string
}

function PartnerRedeemPage({ couponPrefix, ...props }: Props) {
  const dispatch = useDispatch() as AppDispatch
  const intl = useIntl()
  const [codeValue, setCodeValue] = useState('')
  const [isCodeCorrect, setIsCodeCorrect] = useState(false)
  const [validating, setValidating] = useState(false)
  const [codeError, setCodeError] = useState(false)
  const navigate = useNavigate()
  const isPremium = useSelector(selectIsPremium)
  const expiryTime = useSelector(selectSubscriptionExpiryTime)
  const isExpiringWithin14Days = isSubscriptionExpiringWithinDays(
    expiryTime,
    14,
  )
  console.log(
    '[Partner Redeem Page] Is it expiring within 14 days?',
    isExpiringWithin14Days,
  )

  const validateCode = () => {
    if (validating) return

    setIsCodeCorrect(false)
    setCodeError(false)
    setValidating(true)

    let coupon = codeValue
    if (couponPrefix) {
      if (codeValue.substr(0, couponPrefix.length) !== couponPrefix) {
        coupon = couponPrefix + codeValue
      }
    }

    if (coupon === '') {
      setCodeError('Please enter a code.' as any)
      setValidating(false)
      return
    }

    // TODO: remove typescript hack when redux is configured properly
    dispatch(fetchPricing(coupon))
      .then(() => {
        setIsCodeCorrect(true)
        setValidating(false)
        dispatch(setCoupon(coupon))
        setTimeout(() => {
          navigate(`${props.rootUrl}/account`)
        }, 500)
      })
      .catch((error) => {
        // If user is premium and expiring within 14 days, allow the redeem to proceed
        // The purchase will be handled in SignUpFreePurchase which checks expiry
        if (
          isPremium &&
          isExpiringWithin14Days &&
          error.errorDetail &&
          /already.*premium/i.test(error.errorDetail)
        ) {
          setIsCodeCorrect(true)
          setValidating(false)
          dispatch(setCoupon(coupon))
          setTimeout(() => {
            navigate(`${props.rootUrl}/account`)
          }, 500)
        } else {
          setCodeError(error.errorDetail)
          setValidating(false)
        }
      })
  }

  return (
    <div className={`shadow ${props.partnerBoxClasses}`}>
      <h2 className="mb-64 type-28">
        <FormattedMessage {...messages.redeemHeading} />
      </h2>
      <div className="relative">
        <label htmlFor="coupon" className="sr-only">
          {intl.formatMessage(messages.codePlaceholder)}
        </label>
        <input
          data-uid="redeem_input"
          className={cn(
            'border-0 border-b-1 border-LSBrand outline-none ',
            'pl-8',
            { 'mb-12': codeError },
            { 'mb-36': !codeError },
            'type-24',
            'pb-12',
            { 'border-secondary-red': codeError },
          )}
          type="text"
          id="coupon"
          placeholder={intl.formatMessage(messages.codePlaceholder)}
          value={codeValue}
          onChange={(e) => setCodeValue(e.target.value)}
        />
        <span
          className={cn(
            'absolute',
            'right-0',
            'pt-16',
            'pr-8',
            'text-green-dark',
            'w-32',
            {
              'text-secondary-red': codeError,
            },
          )}
        >
          {codeError && <img src={closeRed} alt="" className="h-16" />}
          {isCodeCorrect && <img src={check} alt="" className="h-16" />}
          {validating && (
            <img src={require('media/spinner.gif')} alt="" className="h-16" />
          )}
        </span>
      </div>
      {codeError && (
        <div className="mb-24 text-left text-secondary-red">
          {upperFirst(codeError)}
        </div>
      )}
      <button
        data-uid="redeem_button"
        className="c-button c-button--primary mb-32"
        onClick={validateCode}
      >
        <span>
          <FormattedMessage {...messages.continue} />
        </span>
      </button>
    </div>
  )
}

export default PartnerRedeemPage
